import { DndContext } from "@dnd-kit/core";
import { observer } from "mobx-react-lite";
import Parse, { User } from "parse";
import * as React from "react";
import { useEffect, useState } from "react";
import { saveTicket } from "../../..";
import { getUsername } from "../../../../../_shared";
import { _User } from "../../../../../js/parsegenerated";
import { SaveTicketValuesWithFullMeta } from "../../../creation/types/SaveTicketValues";
import { KanbanContext } from "../../context/KanbanContext";
import { useDragHandler } from "../../hooks/useDragHandler";
import { DragHandlerData } from "../../types/Draggable";
import { KanbanColumn } from "../KanbanColumn";
import { KanbanLayout } from "../KanbanLayout";

type Props = {};

export const UserView = observer((props: Props) => {
  const [user, setUser] = useState<User[]>([]);
  const kanbanManager = React.useContext(KanbanContext);
  const dragHandler = useDragHandler(handleMoveUser);

  useEffect(() => {
    new Parse.Query(User).find().then((user) => {
      setUser(user);
    });
  }, []);

  async function handleMoveUser(data: DragHandlerData) {
    try {
      const assignedUsers = await data.ticketData.ticket
        .relation("assignedusers")
        .query()
        .find();
      const assignedRoles = await data.ticketData.ticket
        .relation("assignedroles")
        .query()
        .find();

      const assignedToUsers: Array<{ type: "role" | "user"; id: string }> =
        assignedUsers
          .filter((user) => user.id !== data.origin)
          .map((user) => ({ type: "user", id: user.id }));

      const assignedToRoles: Array<{ type: "role" | "user"; id: string }> =
        assignedRoles.map((role) => ({ type: "role", id: role.id }));
      assignedToUsers.push({ type: "user", id: data.destination });

      const saveValues: SaveTicketValuesWithFullMeta = {
        existingTicketId: data.ticketData.ticket.id,
        assignedTo: [...assignedToUsers, ...assignedToRoles],
      };
      await saveTicket(saveValues);
      kanbanManager.reload(data.destination);
      kanbanManager.reload(data.origin);
    } catch (err) {
      console.error(err);
    }
  }

  return (
    <div>
      <DndContext onDragEnd={dragHandler}>
        <KanbanLayout>
          {user.map((u: _User) => {
            return (
              <KanbanColumn
                id={u.id}
                key={u.id}
                title={getUsername(u)}
                ticketManagerConfig={{
                  filters: {
                    user: { attribute: "user", value: u.id },
                  },
                }}
              />
            );
          })}
        </KanbanLayout>
      </DndContext>
    </div>
  );
});
